import {style} from 'typestyle'
import * as csstips from 'csstips'

export const bannerImg = style({
    maxWidth: '100%',
    borderRadius: 6
})

export const HomeSwiper = style({
    paddingTop: 15,
    paddingLeft: 15,
    paddingRight: 15,
    lineHeight: 0,
    position: 'relative',
    backgroundColor: '#ffffff'
})

export const playPoint = style({
    position: 'absolute',
    bottom: 5,
    textAlign: 'center',
    left: 0,
    width: '100%'
})

export const point = style({
    display: 'inline-block',
    width: 5,
    height: 5,
    background: 'hsla(0,0%,100%,.5)',
    margin: '0 2.5px',
    borderRadius: 5,
    cursor: 'pointer'
})

export const pointActive = style({
    width: 12,
    height: 5,
    borderRadius: 3,
    backgroundColor: '#fff'
})

export const carouselController = style({
    width: '100%',
    left: 0,
    paddingLeft: 15,
    paddingRight: 15,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
})

export const carouselControllerLeft = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    cursor: 'pointer',
    width: 20,
    height: 40,
    background: 'rgba(0,0,0,.3)',
    float: 'left',
    position: 'absolute',
    top: '50%',
    left: 15,
    transform: 'translateY(-50%)',
    $nest: {
        '& i': {
            display: 'block',
            width: 7,
            height: 7,
            borderTop: '2px solid #ffffff',
            borderRight: '2px solid #ffffff',
            transform: 'rotate(-135deg)'
        }
    }
})

export const carouselControllerRight = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    float: 'right',
    width: 20,
    cursor: 'pointer',
    height: 40,
    right: 15,
    background: 'rgba(0,0,0,.3)',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    $nest: {
        '& i': {
            display: 'block',
            width: 7,
            height: 7,
            borderTop: '2px solid #ffffff',
            borderRight: '2px solid #ffffff',
            transform: 'rotate(45deg)'
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomSwiper/HomeSwiper.style.ts